import { Injectable, inject } from '@angular/core';
import { AppleApplication, SyncCurrentlyConfiguredService } from '@era/locations-sdk';
import { safeMap } from '@era/stores';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, mergeMap } from 'rxjs';
import {
  ConfiguredApplicationsApiActions,
  ConfiguredApplicationsResolverActions,
} from './device-configured-applications.actions';

@Injectable()
export class DeviceConfiguredApplicationsEffects {
  private readonly service = inject(SyncCurrentlyConfiguredService);
  private readonly actions$ = inject(Actions);

  // TODO: We should have an alternative working solution to show the pause icon
  // requestApplicationsForDeviceEffect$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(DeviceActionTypes.DEVICE_API_DEVICES_LOADED),
  //     mergeMap((action: DeviceApiDevicesLoaded) => {
  //       const ids = action.payload.devices.map((x) => x.deviceId);
  //       return of(ConfiguredApplicationsResolverActions.configuredApplicationsRequested({ deviceIds: ids }));
  //     })
  //   )
  // );

  deviceConfiguredApplicationsRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ConfiguredApplicationsResolverActions.configuredApplicationsRequested),
      mergeMap(({ deviceIds }) => {
        const requests = deviceIds.map((deviceId) =>
          safeMap(
            this.service.getCurrentApplications({ udid: deviceId }),
            (configuredApplications: AppleApplication[]) => {
              const mapped = configuredApplications.map((x) => {
                return { deviceId: deviceId, ...x };
              });

              return ConfiguredApplicationsApiActions.configuredApplicationsLoaded({ configuredApplications: mapped });
            },
            (error) => ConfiguredApplicationsApiActions.configuredApplicationsLoadedError({ error })
          )
        );

        return forkJoin(requests).pipe(mergeMap((x) => x));
      })
    );
  });
}
